const loading = (state = { loading: false, sync: false, challenge: false }, action) => {
  switch (action.type) {
    case 'LOADING_START':
      return { ...state, loading: true };
    case 'LOADING_STOP':
      return { ...state, loading: false };
    case 'SYNC_START':
      return { ...state, sync: true };
    case 'SYNC_STOP':
      return { ...state, sync: false };
    case 'CHALLENGE_START':
      return { ...state, challenge: true };
    case 'CHALLENGE_STOP':
      return { ...state, challenge: false };
    default:
      return state;
  }
};

export default loading;
